import { useDrag } from "react-dnd";

interface SidebarDraggableFieldProps {
  field: string;
  type: string;
}

function SidebarDraggableField({ field, type }: SidebarDraggableFieldProps) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "FIELD",
    item: { type: type, name: field },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag as any}
      className="p-3 w-full hover:shadow-lg active:bg-blue-300 active:opacity-50 active:border-2 active:border-black active:border-dashed text-sm flex flex-row justify-between bg-white rounded-lg cursor-grab border border-gray-300 transition-all"
      style={{
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      {field}
      <div className="rounded-full p-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="gray"
          width="20"
          height="20"
        >
          <path d="M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z" />
        </svg>
      </div>
    </div>
  );
}

export default SidebarDraggableField;
